import { useEffect } from 'react';
import {
  withPageLifeCycle,
  createUsePageLifeCycle,
  emitLifeCycles,
  createBaseApp,
  getSearchParams,
} from 'create-app-shared';
import { getInitialData } from 'react-app-renderer';
import ErrorBoundary from './ErrorBoundary';

const { usePageShow, usePageHide } = createUsePageLifeCycle({ useEffect });

// Public API
export {
  createBaseApp,
  getInitialData,
  // LifeCycles api
  emitLifeCycles,
  usePageShow,
  usePageHide,
  withPageLifeCycle,
  ErrorBoundary,
  getSearchParams,
};
